import React, { useState } from "react";
import axios from "axios";
import "./Weather.css";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  function handleResponse(respons) {
    console.log(respons.data);
    setWeatherData({
      ready: true,
      temperature: respons.data.main.temp,
      description: respons.data.weather[0].description,
      humidity: respons.data.main.humidity,
      date: new Date(respons.data.dt * 1000),
      icon: respons.data.weather[0].icon,
      wind: respons.data.wind.speed,
      city: respons.data.name,
      coordinats: respons.data.coord,
    });
  }

  function search() {
    const apiKey = "98f63ab964a6f17c8f87a4018e522a54";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
    //search for a city
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather shadow-sm rounded">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <input
                type="search"
                placeholder="Enter a city..."
                className="form-control"
                autoFocus="on"
                onChange={handleCityChange}
              />
            </div>
            <div className="col-3">
              <input
                type="submit"
                value="Search"
                className="btn btn-primary w-100"
              />
            </div>
          </div>
        </form>
        <WeatherInfo data={weatherData} />
        <WeatherForecast coordinats={weatherData.coordinats}/>
      </div>
    );
  } else {
    search();
    return "Loding";
  }
}
